import { ReactElement } from 'react';
import NodeForm from 'views/flow/form/NodeForm';
import { WorkflowNode, WorkflowNodeType } from 'api/model';
import { Tooltip, useTheme } from '@mui/material';
import { ReactFlowInstance, useReactFlow } from 'reactflow';
import { NodeDetailsTooltipBox } from 'views/flow/canvas/nodes/CustomNode.styles';

type Props = {
  id: string;
  type: string;
  node: WorkflowNode;
  children: ReactElement;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};

function CustomNodeDetailsTooltip({ children, id, type, node, open, onOpen, onClose }: Props) {
  const reactFlow: ReactFlowInstance<WorkflowNode> = useReactFlow();
  const theme = useTheme();

  return (
    <Tooltip
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      title={
        <NodeDetailsTooltipBox>
          <NodeForm
            nodeType={type as WorkflowNodeType}
            nodeId={id}
            initialValues={node}
            flowInstance={reactFlow}
            isTooltipView
          />
        </NodeDetailsTooltipBox>
      }
      placement="top"
      arrow
      slotProps={{
        tooltip: {
          sx: {
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
            fontSize: 16,
            fontWeight: 'normal',
            width: 500,
            maxWidth: 500,
            padding: 0,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '16px',
            boxShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
          },
        },
        arrow: {
          sx: {
            color: theme.palette.background.paper,
            fontSize: 20,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
}

export default CustomNodeDetailsTooltip;
